import React from "react";
import { Navigate } from "react-router-dom";

// Dashboard
import Dashboard from "../feature-module/dashboard/Dashboard";

// Masters
import PatientList from "../feature-module/patients/PatientList";
import ProcedureList from "../feature-module/procedures/ProcedureList";
import DoctorList from "../feature-module/doctors/DoctorList";
import ProductList from "../feature-module/products/ProductList";
import SupplierList from "../feature-module/suppliers/SupplierList";
import AccountHeadList from "../feature-module/account-heads/AccountHeadList";
import ToothList from "../feature-module/tooth/ToothList";
import ShadeList from "../feature-module/shade/ShadeList";
import BankList from "../feature-module/bank/BankList";
import CashSettings from "../feature-module/cash/CashSettings";
import WorkList from "../feature-module/work/WorkList";

// Appointments
import AppointmentCalendar from "../feature-module/appointments/AppointmentCalendar";
import AppointmentList from "../feature-module/appointments/AppointmentList";

// Billing
import InvoiceList from "../feature-module/invoices/InvoiceList";
import InvoiceForm from "../feature-module/invoices/InvoiceForm";
import BillWiseReceiptList from "../feature-module/invoices/BillWiseReceiptList";
import BillWiseReceiptForm from "../feature-module/invoices/BillWiseReceiptForm";
import InvoicePrint from "../feature-module/invoices/InvoicePrint";

// Quotations
import QuotationList from "../feature-module/quotations/QuotationList";
import QuotationForm from "../feature-module/quotations/QuotationForm";
import QuotationPrint from "../feature-module/quotations/QuotationPrint";

// Purchases
import PurchaseList from "../feature-module/purchases/PurchaseList";
import PurchaseReturnList from "../feature-module/purchases/PurchaseReturnList";
import OpeningStock from "../feature-module/purchases/OpeningStock";

// Stock
import CurrentStock from "../feature-module/stock/CurrentStock";
import StockAdjustment from "../feature-module/stock/StockAdjustment";

// Finance
import ExpenseList from "../feature-module/finance/ExpenseList";
import IncomeList from "../feature-module/finance/IncomeList";
import JournalList from "../feature-module/finance/JournalList";
import SupplierAdvance from "../feature-module/finance/SupplierAdvance";
import SupplierPayments from "../feature-module/finance/SupplierPayments";

// Reports
import AppointmentReport from "../feature-module/Reports/AppointmentReport";
import SalesReport from "../feature-module/Reports/SalesReport";
import PurchaseReport from "../feature-module/Reports/PurchaseReport";
import ExpenseReport from "../feature-module/Reports/ExpenseReport";
import BankReport from "../feature-module/Reports/BankReport";
import CashReport from "../feature-module/Reports/CashReport";
import StockReport from "../feature-module/Reports/StockReport";
import StockMovement from "../feature-module/Reports/StockMovement";
import CustomerStatement from "../feature-module/Reports/CustomerStatement";
import SupplierStatement from "../feature-module/Reports/SupplierStatement";
import Receivables from "../feature-module/Reports/Receivables";
import Payables from "../feature-module/Reports/Payables";
import MISReport from "../feature-module/Reports/MISReport";
import DailyReport from "../feature-module/Reports/DailyReport";
import MonthlyCountReport from "../feature-module/Reports/MonthlyCountReport";
import PaymentReport from "../feature-module/Reports/PaymentReport";
import PatientHistory from "../feature-module/Reports/PatientHistory";

// Settings
import UserList from "../feature-module/settings/UserList";
import RolesPermissions from "../feature-module/settings/RolesPermissions";
import AuditLog from "../feature-module/settings/AuditLog";
import TestDataSeeder from "../feature-module/settings/TestDataSeeder";
import ChangePassword from "../feature-module/settings/ChangePassword";

// Auth pages (kept from template)
import SignIn from "../feature-module/pages/login/signin";
import Logout from "../feature-module/pages/Logout";

export const publicRoutes = [
  { path: "/", element: <Navigate to="/dashboard" replace /> },
  { path: "/dashboard", element: <Dashboard /> },

  // Masters
  { path: "/patients", element: <PatientList /> },
  { path: "/procedures", element: <ProcedureList /> },
  { path: "/doctors", element: <DoctorList /> },
  { path: "/products", element: <ProductList /> },
  { path: "/suppliers", element: <SupplierList /> },
  { path: "/account-heads", element: <AccountHeadList /> },
  { path: "/tooth", element: <ToothList /> },
  { path: "/shades", element: <ShadeList /> },
  { path: "/banks", element: <BankList /> },
  { path: "/cash", element: <CashSettings /> },
  { path: "/work", element: <WorkList /> },

  // Appointments
  { path: "/appointments", element: <AppointmentCalendar /> },
  { path: "/appointment-list", element: <AppointmentList /> },

  // Billing
  // Invoices and Medicine Bills share InvoiceList/InvoiceForm — the keys force a fresh mount
  // when navigating between them, so one form's state never leaks into the other.
  { path: "/invoices", element: <InvoiceList key="invoices" /> },
  { path: "/invoices/new", element: <InvoiceForm key="invoice-new" /> },
  { path: "/invoices/:id/edit", element: <InvoiceForm key="invoice-edit" /> },
  { path: "/invoices/bill-wise-receipt", element: <BillWiseReceiptList /> },
  { path: "/invoices/bill-wise-receipt/new", element: <BillWiseReceiptForm /> },
  { path: "/invoices/:id/print", element: <InvoicePrint /> },
  { path: "/medicine-bills", element: <InvoiceList key="medicine-bills" medicine /> },
  { path: "/medicine-bills/new", element: <InvoiceForm key="medicine-bill-new" medicine /> },
  { path: "/medicine-bills/:id/edit", element: <InvoiceForm key="medicine-bill-edit" medicine /> },

  // Quotations
  { path: "/quotations", element: <QuotationList /> },
  { path: "/quotations/new", element: <QuotationForm /> },
  { path: "/quotations/:id/edit", element: <QuotationForm /> },
  { path: "/quotations/:id/print", element: <QuotationPrint /> },

  // Purchases
  { path: "/purchases", element: <PurchaseList /> },
  { path: "/purchase-returns", element: <PurchaseReturnList /> },
  { path: "/opening-stock", element: <OpeningStock /> },

  // Stock
  { path: "/stock", element: <CurrentStock /> },
  { path: "/stock-adjustment", element: <StockAdjustment /> },

  // Finance
  { path: "/expenses", element: <ExpenseList /> },
  { path: "/income", element: <IncomeList /> },
  { path: "/journal", element: <JournalList /> },
  { path: "/supplier-advance", element: <SupplierAdvance /> },
  { path: "/supplier-payments", element: <SupplierPayments /> },

  // Reports
  { path: "/reports/appointments", element: <AppointmentReport /> },
  { path: "/reports/sales", element: <SalesReport /> },
  { path: "/reports/purchases", element: <PurchaseReport /> },
  { path: "/reports/expenses", element: <ExpenseReport /> },
  { path: "/reports/bank", element: <BankReport /> },
  { path: "/reports/cash", element: <CashReport /> },
  { path: "/reports/stock", element: <StockReport /> },
  { path: "/reports/stock-movement", element: <StockMovement /> },
  { path: "/reports/customer-statement", element: <CustomerStatement /> },
  { path: "/reports/supplier-statement", element: <SupplierStatement /> },
  { path: "/reports/receivables", element: <Receivables /> },
  { path: "/reports/payables", element: <Payables /> },
  { path: "/reports/mis", element: <MISReport /> },
  { path: "/reports/daily", element: <DailyReport /> },
  { path: "/reports/monthly", element: <MonthlyCountReport /> },
  { path: "/reports/payments", element: <PaymentReport /> },
  { path: "/reports/patient-history", element: <PatientHistory /> },

  // Settings
  { path: "/users", element: <UserList /> },
  { path: "/roles-permissions", element: <RolesPermissions /> },
  { path: "/audit-log", element: <AuditLog /> },
  { path: "/seed-data", element: <TestDataSeeder /> },
  { path: "/change-password", element: <ChangePassword /> },
];

export const pagesRoute = [
  { path: "/signin", element: <SignIn /> },
  { path: "/logout", element: <Logout /> },
];

export const posRoutes = [];
